import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { ciphEnvironment } from '../cpih-environment';
import { fromFetch } from 'rxjs/fetch';

/**
 * Validates Partner authentication status
 * @param partner The name of the partner
 * @param credentials Partner credentials
 */
export function postValidate(
  this: unknown,
  partner: string,
  credentials: Record<string, unknown>
) {
  return fromFetch(
    new Request(`${ciphEnvironment.resolve(this).validateUrl}/${partner}`, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(credentials),
    })
  ).pipe(ignoreData());
}
